import { createStructuredSelector } from "reselect";

export default createStructuredSelector({
  user: state => state.elab.elabUser.user,
  elabToken: state => state.elab.elabUser.elabToken,
  username: state => state.elab.username,
  password: state => state.elab.password,
  sampleTypes: state => state.elab.sampleTypes,
  sampleType: state => state.elab.sampleType,
  sampleTypeObj: state =>
    state.elab.sampleTypes.find(s => s.sampleTypeID === state.elab.sampleType),
  log: state => state.elab.log,
  gridOptions: state => state.elab.gridOptions,
  getRowStyle: state => state.elab.getRowStyle,
  storageLocations: state => state.elab.storageLocations,
  isFetchingLogin: state => state.elab.isFetchingLogin,
  isFetchingSampleTypes: state => state.elab.isFetchingSampleTypes,
  isFetchingStorageLocations: state => state.elab.isFetchingStorageLocations,
  columnDefs: state => state.elab.columnDefs,
  elabUserFailed: state => state.elab.elabUserFailed
});
